import React from 'react';

import classNames from 'classnames';

import { Loader } from '@nxte-nl/loader';

import styles from './LoadingWrapper.module.css';

export type Props = {
  children?: JSX.Element;
  className?: string;
  loading: boolean;
  loadingBarFixedAtTheCenterOfTheScreen?: boolean;
};

export const LoadingWrapper = React.memo((props: Props) => {
  const {
    loading,
    loadingBarFixedAtTheCenterOfTheScreen = false,
    children,
    className,
  } = props;

  return (
    <div className={classNames(styles.loadingWrapper, className)}>
      {loading && (
        <>
          <div className={styles.overlay} />

          <div className={classNames(styles.loadingBar, {
            [styles.loadingBarFixed]: loadingBarFixedAtTheCenterOfTheScreen,
          })}>
            <Loader />
          </div>
        </>
      )}

      {children}
    </div>
  );
});

LoadingWrapper.displayName = 'LoadingWrapper';
